module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "pressItem"
  }, [_c('header', [(_vm.item.link) ? _c('a', {
    staticClass: "img",
    style: (_vm.imgStyle),
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }) : _c('div', {
    staticClass: "img",
    style: (_vm.imgStyle)
  }), _vm._v(" "), _c('p', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.formattedPubDate))]), _vm._v(" "), _c('h4', [(_vm.item.link) ? _c('a', {
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.headline)
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.headline)
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.excerpt)
    }
  }), _vm._v(" [...]\n    "), (_vm.item.link) ? _c('a', {
    staticClass: "more-link",
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }, [_vm._v("More")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c9255e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/PressItem.vue
// module id = 796
// module chunks = 1